<template>
  <CRow class="material border pl-1 pr-3 py-1 mx-0 full-repeater-row" :id="randomId">
    <CCol class="col-10">
      <CRow>
        <CCol class="mt-2" sm="2">
          <MaterialText data-protocol-field="stueck" :invalid="validationErrors.some(error => error.field.endsWith('.stueck'))" v-model="localMaterial.stueckzahl" placeholder="Stück" form-label="Stück*" />
        </CCol>
        <CCol
          class="mt-2 material-entry__field"
          sm="3"
          @click="showMaterialDetails = true"
          @focusin="showMaterialDetails = true"
        >
          <MaterialText data-protocol-field="artikelnr" :invalid="validationErrors.some(error => error.field.endsWith('.artikelnr'))" rules="" v-model="localMaterial.artikelnr" placeholder="Artikel Nr." label="Art.-Nr." />
        </CCol>
        <CCol
          class="mt-2 material-entry__field"
          sm="6"
          @click="showMaterialDetails = true"
          @focusin="showMaterialDetails = true"
        >
          <MaterialText data-protocol-field="material" :invalid="validationErrors.some(error => error.field.endsWith('.material'))" rules="" v-model="localMaterial.material" placeholder="Material" label="Material" />
        </CCol>
      </CRow>
      <CRow v-if="hasMaterialDetails" class="material-entry__details-row">
        <CCol sm="12">
          <button
            type="button"
            class="material-entry__details-toggle"
            :aria-expanded="showMaterialDetails ? 'true' : 'false'"
            @click="showMaterialDetails = !showMaterialDetails"
          >
            <span>{{ showMaterialDetails ? 'Materialdetails ausblenden' : 'Materialdetails vollständig anzeigen' }}</span>
            <span class="material-entry__details-toggle-icon" aria-hidden="true">{{ showMaterialDetails ? '↑' : '↓' }}</span>
          </button>
          <transition name="material-entry-details">
            <div
              v-show="showMaterialDetails"
              class="material-entry__details"
              role="region"
              aria-label="Vollständige Materialdetails"
            >
              <div
                v-for="detail in materialDetails"
                :key="`material-detail-${randomId}-${detail.key}`"
                class="material-entry__detail"
              >
                <span class="material-entry__detail-label">{{ detail.label }}</span>
                <span class="material-entry__detail-value">{{ detail.value }}</span>
              </div>
            </div>
          </transition>
        </CCol>
      </CRow>
      <CRow v-if="isQuantitySuggestionsVisible && visibleQuantitySuggestions.length > 0">
        <CCol sm="12" class="mt-2">
          <div class="qty-suggestions-row">
            <CButton
              v-for="qty in visibleQuantitySuggestions"
              :key="`qty-${randomId}-${qty}`"
              color="secondary"
              variant="outline"
              size="sm"
              class="qty-suggestion-button"
              @click="applyQuantitySuggestion(qty)"
            >
              {{ formatQuantitySuggestionLabel(qty) }}
            </CButton>
          </div>
        </CCol>
      </CRow>
    </CCol>
    <CCol class="col-2 mt-2 text-right m-auto center">
      <CButton
        color="danger"
        variant="outline"
        size="sm"
        class="center m-auto center vertical-middle"
        v-c-tooltip="{content: 'Löschen', placement:'left'}"
        v-on:click="deleteEntry(randomId)">
        <CIcon name="cil-trash"/>
      </CButton>
    </CCol>
  </CRow>
</template>

<script>
import MaterialText from '@/components/FormElements/Text'

export default {
  name: 'formular-material',
  components: {
    MaterialText
  },
  props: {
    validationErrors: { type: Array, default: () => [] },
    value: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      randomId: 'repeater-row-material-' + this.getRandomInt(10000),
      showMaterialDetails: false
    }
  },
  computed: {
    isQuantitySuggestionsVisible () {
      return process.env.VUE_APP_ENABLE_PROTOKOLL_MATERIAL_QTY_SUGGESTIONS !== 'false'
    },
    quantitySuggestions () {
      if (!this.localMaterial) {
        return []
      }

      const primarySuggestions = Array.isArray(this.localMaterial.qtySuggestions) ? this.localMaterial.qtySuggestions : []
      const recentSuggestions = Array.isArray(this.localMaterial.recentQtySuggestions) ? this.localMaterial.recentQtySuggestions : []
      const seenSuggestions = {}

      return primarySuggestions.concat(recentSuggestions).filter((value) => {
        const normalizedValue = String(value || '').trim()
        if (normalizedValue === '' || seenSuggestions[normalizedValue]) {
          return false
        }

        seenSuggestions[normalizedValue] = true
        return true
      })
    },
    visibleQuantitySuggestions () {
      return this.quantitySuggestions.slice(0, 6)
    },
    materialDetails () {
      return [
        { key: 'artikelnr', label: 'Art.-Nr.', value: this.localMaterial.artikelnr },
        { key: 'material', label: 'Material', value: this.localMaterial.material }
      ].filter((detail) => String(detail.value || '').trim() !== '')
    },
    hasMaterialDetails () {
      return this.materialDetails.some((detail) => String(detail.value || '').length > 22)
    },
    localMaterial: {
      get () {
        if (!this.value) {
          return {}
        }

        return this.value
      },
      set (localMaterial) { localMaterial.uid = this.randomId; this.$emit('input', localMaterial) }
    }
  },
  methods: {
    applyQuantitySuggestion (quantity) {
      const nextMaterial = Object.assign({}, this.localMaterial)
      nextMaterial.stueckzahl = this.formatQuantitySuggestionLabel(quantity)
      this.localMaterial = nextMaterial
    },
    formatQuantitySuggestionLabel (quantity) {
      const normalizedQuantity = String(quantity || '').trim()
      return /^[-+]?\d+(?:[.,]\d+)?$/.test(normalizedQuantity) ? `${normalizedQuantity}x` : normalizedQuantity
    },
    getRandomInt (max) {
      return Math.floor(Math.random() * max)
    },
    deleteEntry (entry) {
      this.$emit('remove')
    }
  }
}
</script>

<style lang="scss">
.repeater-drop-zone:first-child button[title="Remove block"]{
  display: none !important;
}

.repeater-drop-zone button[content="Duplicate"]{
  display: none !important;
}

.qty-suggestions-row {
  display: none;
  gap: 0.5rem;
  grid-template-columns: repeat(auto-fit, minmax(120px, max-content));
  justify-content: start;
}

.qty-suggestion-button {
  border-radius: 999px;
  font-size: 0.95rem;
  min-height: 2.5rem;
  padding: 0.45rem 0.9rem;
}

.material-entry__details-row {
  margin-top: 0.7rem;
}

.material-entry__details-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  min-height: 2.2rem;
  padding: 0.35rem 0.75rem;
  border: 1px solid #cfd8e3;
  border-radius: 999px;
  background: #f8fbff;
  color: #315170;
  font-size: 0.82rem;
  font-weight: 700;
}

.material-entry__details-toggle:focus {
  outline: 2px solid rgba(47, 109, 176, 0.28);
  outline-offset: 2px;
}

.material-entry__details-toggle-icon {
  font-size: 0.95rem;
  line-height: 1;
}

.material-entry__details {
  display: grid;
  gap: 0.55rem;
  margin-top: 0.5rem;
  padding: 0.65rem 0.75rem;
  border: 1px solid rgba(47, 109, 176, 0.16);
  border-radius: 0.75rem;
  background: #f7fbff;
  box-shadow: 0 6px 18px rgba(31, 45, 61, 0.08);
}

.material-entry__detail {
  min-width: 0;
}

.material-entry__detail-label {
  display: block;
  margin-bottom: 0.1rem;
  color: #6b7b8f;
  font-size: 0.68rem;
  font-weight: 700;
}

.material-entry__detail-value {
  display: block;
  color: #1f2d3d;
  font-size: 0.88rem;
  line-height: 1.35;
  white-space: normal;
  word-break: normal;
  overflow-wrap: anywhere;
}

.material-entry-details-enter-active,
.material-entry-details-leave-active {
  transition: opacity 0.16s ease, transform 0.16s ease;
}

.material-entry-details-enter,
.material-entry-details-leave-to {
  opacity: 0;
  transform: translateY(-0.25rem);
}

.c-dark-theme {
  .material-entry__details-toggle {
    border-color: #39465c;
    background: #252b3a;
    color: #d8e7ff;
  }

  .material-entry__details {
    border-color: #35435a;
    background: #202637;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.24);
  }

  .material-entry__detail-label {
    color: #9fb0c6;
  }

  .material-entry__detail-value {
    color: #eef4ff;
  }
}

@media (max-width: 767.98px) {
  .material.full-repeater-row {
    padding-right: 0.35rem !important;
  }

  .material-entry__field {
    padding-left: 0.15rem;
    padding-right: 0.15rem;
  }

  .material-entry__details-row > .col-sm-12 {
    padding-left: 0.15rem;
    padding-right: 0.15rem;
  }

  .material-entry__details-row {
    margin-top: 0.85rem;
  }

  .material-entry__details-toggle {
    width: 100%;
  }

  .material-entry__details {
    margin-right: -0.2rem;
    margin-left: -0.2rem;
  }

  .qty-suggestions-row {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .qty-suggestion-button {
    min-height: 2.75rem;
    width: 100%;
  }
}
</style>
